// extracted by mini-css-extract-plugin
export default {"histogramWrapper":"Histogram_histogramWrapper__rAeI1"};